export const BASE_URL = 'https://daxingwhg.com';
//export const BASE_URL = 'http://localhost:8000';

// export const BASE_URL = 'http://39.103.130.49:8003';
export const PROXY_NAME = '/ssApi';
export const DESCONFIG3 = {
	key: 'WfJTKO9S4eLkrPz2JKrAnzdb',
	iv: 'D076D35C',
	pubkeyHex: '04AF0FCC45059AA342221352E5268614F2FF7A430497B156C0DEE6E751AB44E4957E9E69299E2CD38E25985B7BD34E0E7BBA683DE4725A6A8CD07E19BFF8BEF44D'
};
export const WX_APP_ID = 'wx3898fe4d207e10ac';
